<template>
	<div class="parent">
		<div class="scroll" style="height:calc(100vh - 110px); display:flex; flex-direction: row;">
			<div class="lefttable">
                <div style="height:30px; padding:15px; font-size:16px" id="jobInfoText"></div>
                <hr style="margin-left:25px;margin-right:25px;"/>
                <table>
                    <tr class="hideborder" v-if="column_data[12]!='null'">
                        <td colspan=2 style="padding:0px; height:0px;"><div class="parentinvoice">Parent Invoice:({{column_data[12]}})</div></td>
                    </tr>
                    <tr>
                        <td style="width:200px;"><b>Invoice Prep</b></td>
                        <td><div>{{term}}, {{column_data[8]}}</div></td>
                    </tr>
                    <tr v-if="column_data[11]!=null">
                        <td><b>{{column_names[11]}}</b></td>
                        <td><div>{{column_data[11]}}</div></td>
                    </tr>
                    <tr>
                        <td><b>{{column_names[1]}}</b></td>
                        <td>
                            <div v-for="(poNumber,index) in poNumbers" style="margin:0px;">
                                <input :id="'po-'+poNumber.toString().split('•')[0]" :value="'po-'+poNumber.toString().split('•')[0]" v-model="poNumberSelect" type="radio" style="width:50px;">{{poNumber[0]}}</input>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{column_names[2]}}</b></td>
                        <td><div>
                            <datetime
                            v-model="column_data[2]"
                            style="width:100%"
                            />
                        </div></td>
                    </tr>
                    <tr>
                        <td><b>{{column_names[3]}}</b></td>
                        <td><div>
                            <datetime
                            v-model="column_data[3]"
                            style="width:100%"
                            />
                        </div></td>
                    </tr>
                    <tr>
                        <td><b>{{column_names[4]}}</b></td>
                        <td><div>
                            <textarea
                            id="notesTextArea"
                            v-model="column_data[4]"
                            style="width:100%; min-height:125px;"
                            />
                        </div></td>
                    </tr>
                    <tr v-if="perms.includes('77')">
                        <td><b>Settings</b></td>
                        <td><div style="display:inline-block;">
                            <div style="float:left;">
                                <b>{{column_names[10]}}</b>
                                <input
                                type=checkbox
                                v-model="column_data[10]"
                                v-on:click="updateKey()"
                                style="width:30px;"
                                />
                            </div>
                            <div style="float:left; width:50px; height:30px;"></div>
                            <div style="float:left;">
                                <button style="height:30px;" v-on:click="addTimesToDescription()">Add Date To Description</button>
                            </div>
                            <div style="float:left;">
                                <button style="height:30px;" v-on:click="removeTimesFromDescription()">Remove Date From Description</button>
                            </div>
                        </div></td>
                    </tr>
                    <tr :key="'time_'+keyTimes">
                        <td><b>Times</b></td>
                        <td><div>
                            <table>
                                <tr>
                                    <td></td>
                                    <td><b>From</b></td>
                                    <td><b>To</b></td>
                                    <td><b>Description</b></td>
                                    <td><b>Type</b></td>
                                    <td><b>Persons</b></td>
                                </tr>
                                <tr v-for="(time,index) in times">
                                    <td>
                                        <button style="width:30px;" v-on:click="removeTime(index)"><font-awesome-icon icon="trash" /></button>
                                    </td>
                                    <td><div style="width:400px;">
                                        <datetime
                                        v-model="times[index][1]"
                                        style="width:100%"
                                        />
                                    </div></td>
                                    <td><div style="width:400px;">
                                        <datetime
                                        v-model="times[index][2]"
                                        style="width:100%"
                                        />
                                    </div></td>
                                    <td><div style="width:400px;">
                                        <textarea
                                        style="width:100%; min-height:75px;"
                                        v-model="times[index][5]"
                                        />
                                    </div></td>
                                    <td><div style="width:125px;">
                                        <autocomplete
                                        :type="autoWorkerTypeID"
                                        v-model="times[index][3]"
                                        style="width:100%"
                                        />
                                    </div></td>
                                    <td><div style="width:75px;">
                                        <input
                                        style="width:100%"
                                        type="number"
                                        v-model="times[index][4]"
                                        />
                                    </div></td>
                                </tr>
                                <tr>
                                    <td style="width:50px;">
                                        <button style="width:30px;" v-on:click="addTime()"><font-awesome-icon icon="plus" /></button>
                                    </td>
                                    <td/><td/><td/><td/>
                                </tr>

                            </table>
                        </div></td>
                    </tr>

                    <tr>
                        <td><b>Materials</b></td>
                        <td><div>
                            <table>
                                <tr>
                                    <td></td>
                                    <td><b>Name</b></td>
                                    <td><b>Description</b></td>
                                    <td><b>Rate</b></td>
                                    <td><b>Quantity</b></td>
                                </tr>
                                <tr v-for="(material,index) in materials">
                                    <td>
                                        <button style="width:30px;" v-on:click="removeMaterial(index)"><font-awesome-icon icon="trash" /></button>
                                    </td>
                                    <td><div>
                                        <autocomplete
                                        :type="autoMaterialID"
                                        v-model="materials[index][1]"
                                        :index=index
                                        v-on:full="setMaterialFull"
                                        style="width:100%"
                                        />
                                    </div></td>
                                    <td><div>
                                        <input
                                        style="width:100%"
                                        v-model="materials[index][2]"
                                        />
                                    </div></td>
                                    <td><div>
                                        <input
                                        style="width:100%"
                                        v-model="materials[index][4]"
                                        />
                                    </div></td>
                                    <td><div>
                                        <input
                                        style="width:100%"
                                        type="number"
                                        v-model="materials[index][3]"
                                        />
                                    </div></td>
                                </tr>
                                <tr>
                                    <td style="width:50px;">
                                        <button style="width:30px;" v-on:click="addMaterial()"><font-awesome-icon icon="plus" /></button>
                                    </td>
                                    <td/><td/><td/>
                                </tr>

                            </table>
                        </div></td>
                    </tr>

                    <tr>
                        <td><b>Additional WO Numbers</b></td>
                        <td><div>
                            <table>
                                <tr>
                                    <td style="width:50px;">
                                        <button v-on:click="editAdditionalJoborders()">Edit</button>
                                    </td>
                                    <td v-for="(name,index) in additionalJobOrderNames"><b>{{name}}</b></td>
                                </tr>
                                <tr v-for="(joborder,i) in additionalJobOrders">
                                    <td style="width:50px;">
                                    </td>
                                    <td v-for="(data,j) in joborder">
                                        <p style="margin:0px; padding:0px;">{{data}}</p>
                                    </td>
                                </tr>
                            </table>
                        </div></td>
                    </tr>
                </table>
            </div>

			<div class="righttable">
				<div>
					<button v-on:click="changePage(-1)" style="float:left; width:100px;"><</button>
					<button v-on:click="changePage(1)" style="float:right; width:100px;">></button>
					<p style="margin:0 auto 0 auto; width:100px; text-align:center;">{{invDocPage}} / {{documents.length}}</p>
				</div>
				<layout-10
					v-if="perms.includes('77') && invDocPage==0"
					:term="term"
					:column_data="column_data"
					:minTimeActive="column_data[10]"
					:times="times"
					:materials="materials"
					:ponumber="getPoNumber"
					:idAddrs="idAddrs"
					:idHourCalc="idHourCalc"
					:idMaterialRate="idMaterialRate"
					:showMiscText=true
					style="width:100%"
					 :key="'preview_'+keyPreview"
				></layout-10>

				<div class="scroll" style="width:95%; height:calc(100vh - 225px);" v-for="(documentid, index) in documents" v-if="index+1 == invDocPage">
					<document :id="index" :dir="'doc_'+documentid+'.jpg'" :doc_id="documentid"></document>
				</div>
			</div>

		</div>
		<div class="nav-bar">
			<div>
				<button v-on:click="saveTable()">Save</button>
				<button v-on:click="completePrep()">Complete Final Report Prep</button>
				<button v-if="perms.includes('84')" v-on:click="completeInvoice()" :disabled="column_data[8]!='PrepComplete'">Create Invoice</button>
			</div>
		</div>

	</div>
</template>

<script>
import {SUGGESTIONS} from './../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		idTime: Number,
		idMaterial: Number,
		idPonumber: Number,
		idComplete: Number,
		idAddrs: Number,
		idHourCalc: Number,
		idMaterialRate: Number,
		idDocuments: Number,
		idAdditionaljoborders: Number,
		term: String,
    },
	data() {
		return {
			autoWorkerTypeID: SUGGESTIONS.WORKER_TYPE,
			autoMaterialID: SUGGESTIONS.MATERIAL,

			poNumberSelect:'',
			poNumbers:[],
			times:[],
			materials:[],
			documents:[],

			additionalJobOrderNames:[],
			additionalJobOrders:[],

			column_names:[],
			column_data:[],

			invDocPage:0,

			perms:[],

			keyTimes:0,
			keyPreview:0,
		}
	},
	//to fix the datetime issue give each datetime a key and increment that key everytime times gets changed
	//with each datetime having its own key value it should not keep previous values
	async created (){
		this.perms = api.getPerms();
		if(!this.perms.includes('77')){
			this.invDocPage=1;
		}
		this.getData()
	},
	methods:{
		changePage(amt){
			this.invDocPage+=amt;
			if(this.perms.includes('77')){
				if(this.invDocPage<0){
					this.invDocPage=0;
				}
			}else{
				if(this.invDocPage<1){
					this.invDocPage=1;
				}
			}

			if(this.invDocPage>this.documents.length){
				this.invDocPage=this.documents.length;
			}
		},
		editAdditionalJoborders(){
			router.push('/0509?q='+this.term);
		},
		updateKey(){
			this.keyPreview++;
		},
		getData(){
			this.getSearchData()
			this.getTimes()
			this.getMaterials()
			this.getPoNumbers()
			this.getDocuments();
			this.getAdditionaljoborders();
		},
		getSearchData(){
			this.search(this.id).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					this.column_data = res.data.data.column_data[0];
					this.column_names = res.data.data.column_names;

					this.poNumberSelect="po-"+this.column_data[1];
					this.column_data[10] = (this.column_data[10]==1?true:false)

					var lines = this.column_data[4].split('\n').length;
					document.getElementById("notesTextArea").style.height = lines*25+"px";

					this.setJobData();
				}
			})
		},
		setJobData(){

			var list=[0,5,6,9,13,7]
			var text = ""
			for(var i = 0;i<list.length;i++){
				text+="<div style='float:left; height:30px'>"
				text+="<b>"+this.column_names[list[i]]+":</b> "
				if(i==0){
					text+="<p style='float:right; height:30px;'>"+this.column_data[list[i]]+"</p>"
				}else{
					text+=this.column_data[list[i]]
				}
				text+="&emsp;</div>"
			}
			document.getElementById("jobInfoText").innerHTML = text;
		},
		completePrep(){
			this.saveTable(false).then((res) => {
				this.insert(this.idComplete,null).then((res) => {
					this.getSearchData()
					//alert("Invoice prep "+this.term+" status set to completed")
				})
			})
		},
		completeInvoice(){
			this.saveTable(false).then((res) => {
				api.postData(
					{
						type:"button",
						data:{
							pageid:this.id,
							data:[
								this.term
							],
						}
					}
				).then((res) => {
					if(res.data.complete==true){
						alert("Invoice created")
					}else{
						alert("Invoice is being deleted and can't be recreated until it is finished deleting")
					}
				})
			})
		},
		getTimes(){
			this.search(this.idTime).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					if(res.data.data.column_data[0].length>0){
						this.times = res.data.data.column_data;
					}
				}
			})
		},
		addTime(){
			this.times.push([null,null,null,'1• Engineer','1','Engineer Straight Time\nEngineer Overtime\nEngneer Extended Overtime']);
		},
		removeTime(index){
			this.times.splice(index,1);
			for(var i =0;i<this.times.length;i++){

			}
		},
		addTimesToDescription(){
			for(var i = 0;i<this.times.length;i++){
				if(this.times[i][1]!=null){
					var time = this.times[i][1].split(' ')[0];
					var timesText = this.times[i][5].split('\n');
					for(var j = 0;j<timesText.length;j++){
						var timeString = timesText[j].trim();
						if(/^\d{4}-\d{2}-\d{2}$/.test(timeString.substr(timeString.length-10, 10))){
							timeString = timeString.substr(0,timeString.length-11);
						}

						timesText[j] = timeString+' '+time;
					}
					this.times[i][5] = timesText.join('\n');
				}
			}
			this.keyTimes++;
			this.keyPreview++;
		},
		removeTimesFromDescription(){
			for(var i = 0;i<this.times.length;i++){
				var timesText = this.times[i][5].split('\n');
				for(var j = 0;j<timesText.length;j++){
					var timeString = timesText[j].trim();
					if(/^\d{4}-\d{2}-\d{2}$/.test(timeString.substr(timeString.length-10, 10))){
						timeString = timeString.substr(0,timeString.length-11);
					}

					timesText[j] = timeString;
				}
				this.times[i][5] = timesText.join('\n');
			}
			this.keyTimes++;
			this.keyPreview++;
		},
		getMaterials(){
			this.search(this.idMaterial).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					if(res.data.data.column_data[0].length>0){
						this.materials = res.data.data.column_data;

						for(var i = 0;i < this.materials.length;i++){
							this.materials[i][4] = parseFloat(this.materials[i][4]).toFixed(2);
						}
					}
				}
			})
		},
		addMaterial(){
			this.materials.push([null,null,'','1',0.00]);
		},
		removeMaterial(index){
			this.materials.splice(index,1);
		},
		setMaterialFull(index,value){
			if(value!=null){
				if((this.materials[index][2]==null || this.materials[index][2]=='') && value[1]!=null){
					this.materials[index][2]=value[1];
				}
				if((this.materials[index][4]==null || this.materials[index][4]=='') && value[2]!=null){
					this.materials[index][4]=parseFloat(value[2]).toFixed(2);
				}
			}
		},
		getPoNumbers(){
			this.search(this.idPonumber).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					this.poNumbers = res.data.data.column_data;
				}
			})
		},
		getDocuments(){
			this.search(this.idDocuments).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					this.documents = [];
					for(var i = 0;i<res.data.data.column_data.length;i++){
						this.documents.push(res.data.data.column_data[i][0]);
					}
				}
			})
		},
		getAdditionaljoborders(){
			this.search(this.idAdditionaljoborders).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					if(res.data.data.column_data[0].length>0){
						this.additionalJobOrders = res.data.data.column_data;
						this.additionalJobOrderNames = res.data.data.column_names;
					}
				}
			})
		},
		search(id){
			return(api.postData(
				{
					type:"search",
					data:{
						pageid:id,
						data:[
							this.term
						],
					}
				}
			))
		},
		saveTable(print = true){

			var promises = [];
			promises.push(
				this.insert(this.id, [this.poNumberSelect.substr(3), this.column_data[2],this.column_data[3],this.column_data[4],this.column_data[10]])
			);
			promises.push(
				this.insert(this.idTime, this.times).then((res) => {
					this.getTimes();
				})
			);
			promises.push(
				this.insert(this.idMaterial, this.materials).then((res) => {
					this.getMaterials();
				})
			);

			return Promise.all(promises).then((results) => {
				if(print==true){
					alert("Invoice prep "+this.term+" saved")
				}
				this.getData()
			});
		},
		insert(id, insertData){
			return(api.postData(
				{
					type:"insert",
					data:{
						term:this.term,
						pageid:id,
						data:insertData,
					}
				}
			))
		},
	},
	computed:{
		getPoNumber(){
			for(var i = 0;i<this.poNumbers.length;i++){
				if(this.poNumbers[i][0]!=null){
					if(this.poNumbers[i][0].split('•')[0]==this.poNumberSelect.split("-")[1]){
						return this.poNumbers[i][0]
					}
				}
			}
			return null;
		},
	}
}
</script>

<style scoped>
.hidetable{
	table-layout:fixed;
	background-color: #ffffff;
	border-collapse: collapse;
	border: 0px solid black;
	empty-cells: show;
}

.lefttable{
    flex-grow:1;
    margin-right:16px;
}

.righttable{
	flex:0 0 35%;
}

.parentinvoice {
	padding:0px 5px 0px 5px;
	font-size:15px;
	font-weight: bold;
	color:#000000;
	background-color:#cfcfff;
	border-radius: 5px;
	border:2px solid #2929d6;
	margin:0px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/layout_9.vue